module.exports = __webpack_public_path__ + "static/media/13.27c09354.png";